import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import TryIt from "@/components/site/TryIt";
import InspectorMoment from "@/components/site/InspectorMoment";
import Process from "@/components/site/Process";
import PainPoints from "@/components/site/PainPoints";
import CertificateMock from "@/components/site/CertificateMock";
import About from "@/components/site/About";
import FeaturesMoment from "@/components/site/FeaturesMoment";
import TrainingSuite from "@/components/site/TrainingSuite";
import Pricing from "@/components/site/Pricing";
import BottomCTA from "@/components/site/BottomCTA";
import FAQ from "@/components/site/FAQ";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Landing() {
  return (
    <div
      data-testid="landing-page"
      className="min-h-screen bg-[#040914] text-slate-100 overflow-x-hidden"
    >
      <Nav />
      <Hero />
      <TryIt />
      <InspectorMoment />
      <Process />
      <PainPoints />
      <CertificateMock />
      <About />
      <FeaturesMoment />
      <TrainingSuite />
      <Pricing />
      <BottomCTA />
      <FAQ />
      <Contact />
      <Footer />
    </div>
  );
}
